export default __webpack_public_path__ + "img/login.a6f0905b.jpg";